import React from "react";
import { YhButton, ButtonVariant } from "../../../ui/YhButton";

interface CustomProps {
  label: string;
  onClick: Function;
  loading?: boolean;
  customClasses?: any;
  buttonType?: string;
  variant?: "primary" | "secondary" | "green" | "ghost" | "danger";
  color?: "primary" | "secondary";
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  disabled?: boolean;
  value?: any;
  fullWidth?: boolean;
  className?: string;
}

const CustomButton = (props: CustomProps) => {
  const mapVariant = (): ButtonVariant => {
    if (props.variant) return props.variant;
    if (props.color) return props.color;

    switch (props.buttonType) {
      case "secondaryBtn":
      case "secondary":
      case "back":
        return "secondary";
      case "success":
        return "green";
      case "iconBtn":
        return "ghost";
      case "primaryBtn":
      case "primary":
      default:
        return "primary";
    }
  };

  const isIcon = props.buttonType === "iconBtn";
  const fullWidth =
    props.fullWidth !== undefined
      ? props.fullWidth
      : !isIcon && props.buttonType !== "secondaryBtn";

  const extraClass =
    "cursor-pointer " +
    (isIcon
      ? "!w-auto !min-w-0 !px-2 "
      : props.customClasses?.width === "auto" || props.customClasses?.minWidth
      ? "!w-auto "
      : "") +
    (props.className || "");

  return (
    <YhButton
      value={props.value}
      startIcon={props.startIcon}
      endIcon={props.endIcon}
      variant={mapVariant()}
      loading={!!props.loading}
      disabled={props.disabled}
      fullWidth={fullWidth}
      className={extraClass}
      onClick={(event) => props.onClick(event)}
      style={
        props.customClasses
          ? {
              ...(props.customClasses.minWidth
                ? { minWidth: props.customClasses.minWidth }
                : {}),
              ...(props.customClasses.width
                ? { width: props.customClasses.width }
                : {}),
              ...(props.customClasses.borderRadius
                ? { borderRadius: props.customClasses.borderRadius }
                : {}),
            }
          : undefined
      }
    >
      {props.label}
    </YhButton>
  );
};

export default CustomButton;
